import axios from 'axios'
import tokenService from './token'
import { createApiUrl } from '../config/api'

const baseUrl = createApiUrl('/api/resources/')

const buildListUrl = (resourcetype, query, page) => {
    const params = []
    if (resourcetype) params.push(`resourcetype=${encodeURIComponent(resourcetype)}`)
    if (page) params.push(`page=${page}`)
    if (query) params.push(query)
    return params.length ? `${baseUrl}?${params.join('&')}` : baseUrl
}

const retrieve = async (resourcetype, query = '', page = 1) => {
    const res = await axios.get(buildListUrl(resourcetype, query, page), tokenService.getAuthHeader())
    return res.data
}

const retrieveSingle = async (id) => {
    const res = await axios.get(`${baseUrl}${id}/`, tokenService.getAuthHeader())
    return res.data
}

const create = async (resourcetype, payload) => {
    const body = { ...payload, resourcetype }
    const res = await axios.post(baseUrl, body, tokenService.getAuthHeader())
    return res.data
}

const update = async (id, payload, resourcetype) => {
    const body = resourcetype ? { ...payload, resourcetype } : payload
    const res = await axios.put(`${baseUrl}${id}/`, body, tokenService.getAuthHeader())
    return res.data
}

// Partial update: sends only the given fields, so nothing else on the row (or its
// nested sub-resources) is touched.
const patch = async (id, payload) => {
    const res = await axios.patch(`${baseUrl}${id}/`, payload, tokenService.getAuthHeader())
    return res.data
}

const destroy = async (id) => {
    const res = await axios.delete(`${baseUrl}${id}/`, tokenService.getAuthHeader())
    return res
}

const resourcesService = { retrieve, retrieveSingle, create, update, patch, destroy }

export default resourcesService
